// extracted by mini-css-extract-plugin
module.exports = {"id":"huggg-id_id__KDENt"};